import { render, staticRenderFns } from "./c-rect-create.vue?vue&type=template&id=e15453ec&"
import script from "./c-rect-create.vue?vue&type=script&lang=js&"
export * from "./c-rect-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports